import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dzjqqxzc: FaireBrandEntity = {
  token: "b_dzjqqxzc",
  type: "brand",
  name: "MACHETE",
  avatarUrl:
    "https://cdn.faire.com/fastly/a3b6965f80424edb02f8d8187a5d8ad7d9893d911317f0728fadd6d0f91be217.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bcdfb715da09084dbad62432ccdf134328d62233b457c484b697a35b2dd89d6a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a3b6965f80424edb02f8d8187a5d8ad7d9893d911317f0728fadd6d0f91be217.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bcdfb715da09084dbad62432ccdf134328d62233b457c484b697a35b2dd89d6a.png",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 40,
  isTopShop: true,
  isInsider: true,
  description:
    "Machete was born from the belief that everyday accessories can be beautiful, long-lasting, and sustainable. JJ Matchett started MACHETE in 2015 with four original earring designs and a belief that everyday accessories, if made with care and intention, could become heirloom-quality keepsakes. With a background in vintage buying, she knew that thoughtful design and craftsmanship resulted in products that looked good, felt good, and would last a lifetime. She took that approach to those first few pairs of acetate earrings, and MACHETE took off from there.\n\nToday, we offer a full line of handcrafted accessories available in our online store and hundreds of independent retailers around the globe, while our Atlanta-based team is still bringing the same level of creativity and care to every thing we make. We hope you find something to love.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:33.386Z",
    importedBy: "entity-db-cli",
  },
};
